// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// ** Axios Imports
import axios from "axios";

export const setLoading = createAsyncThunk("posSettings/setLoading", async (loadingState) => ({ ...loadingState }));

export const getData = createAsyncThunk("posSettings/getData", async (params, { dispatch }) => {
   dispatch(setLoading({ getData: true }));
   const response = await axios.get("/Settings/SelectOrganizationPosSettings", { params });

   dispatch(setLoading({ getData: false }));
   return {
      params,
      data: response.data,
   };
});

export const posSettings = createSlice({
   name: "posSettings",
   initialState: {
      data: {},
      params: {},
      loadingState: { getData: false, getCodeCustomization: false },
      // allData: []
   },
   reducers: {},
   extraReducers: (builder) => {
      builder
         .addCase(getData.fulfilled, (state, action) => {
            state.data = action.payload.data.data;
            state.params = action.payload.params;
         })
         .addCase(setLoading.fulfilled, (state, action) => {
            state.loadingState = action.payload;
         });
   },
});

export default posSettings.reducer;
